import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import api from "../common/api";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ClientInvoicingConfig = ({ id }) => {
  const [clientInvoicingConfig, setClientInvoicingConfig] = useState({});
  const [client, setClient] = useState({});
  const [charges, setCharges] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [snackbar, setSnackbar] = useState({
    message: "",
    open: false,
    severity: "success"
  });

  const token = localStorage.getItem("userToken");
  const fetchClient = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(
        api.clients().get(clientInvoicingConfig.client_id),
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      setClient(res.data[0]);
    } catch (error) {
      console.error("Error fetching client:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchClientInvoicingConfig = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(api.clientInvoicingConfigs().show(id), {
        headers: { Authorization: `Bearer ${token}` }
      });
      setClientInvoicingConfig(res.data);
      let available_charges = [];
      res.data.items.map((val, idx) => {
        available_charges.push({
          id: val.service_charge_id,
          name: val.service_charge.charge.name
        });
      });
      available_charges = available_charges.filter((val, idx) => {
        return available_charges.findIndex(v => v.id === val.id) === idx;
      });
      setCharges(available_charges);
    } catch (error) {
      console.error("Error fetching client invoicing config:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchClientInvoicingConfig();
  }, [id]);

  useEffect(() => {
    if (clientInvoicingConfig.client_id) {
      fetchClient();
    }
  }, [clientInvoicingConfig.client_id]);

  const handleSubmit = async () => {
    setSaving(true);
    const token = localStorage.getItem("userToken");
    const formData = new FormData();
    formData.append(
      "client_invoicing_config[client_id]",
      clientInvoicingConfig.client_id
    );
    formData.append(
      "client_invoicing_config[start_date]",
      clientInvoicingConfig.start_date ? clientInvoicingConfig.start_date : ""
    );
    formData.append(
      "client_invoicing_config[end_date]",
      clientInvoicingConfig.end_date ? clientInvoicingConfig.end_date : ""
    );

    var i = 0;
    clientInvoicingConfig.items.forEach(element => {
      formData.append(
        "client_invoicing_config[items][" + i + "][service_charge_id]",
        element.service_charge_id ? element.service_charge_id : ""
      );
      formData.append(
        "client_invoicing_config[items][" + i + "][description]",
        element.description ? element.description : ""
      );
      formData.append(
        "client_invoicing_config[items][" + i + "][invoice_details]",
        element.invoice_details ? element.invoice_details : false
      );
      formData.append(
        "client_invoicing_config[items][" + i + "][vehicle_detailed]",
        element.vehicle_detailed ? element.vehicle_detailed : false
      );
      formData.append(
        "client_invoicing_config[items][" + i + "][version_detailed]",
        element.version_detailed ? element.version_detailed : false
      );
      formData.append(
        "client_invoicing_config[items][" + i + "][period_detailed]",
        element.period_detailed ? element.period_detailed : false
      );
      i++;
    });
    formData.set("_method", "PATCH");
    return axios
      .post(
        api.clientInvoicingConfigs().patch(clientInvoicingConfig.id),
        formData,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      )
      .then(res => {
        setSnackbar({
          open: true,
          message: "Configuración actualizado con éxito",
          severity: "success"
        });
        setSaving(false);
        fetchClientInvoicingConfig();
      })
      .catch(err => {
        const { errors } = err.response.data;
        let error_msg = "";
        if (errors) {
          for (let key in errors) {
            error_msg += errors[key];
          }
          setSnackbar({
            open: true,
            message: error_msg,
            severity: "error"
          });
          setSaving(false);
        } else {
          setSnackbar({
            open: true,
            message: "Ha ocurrido un error al guardar los cambios",
            severity: "error"
          });
          setSaving(false);
        }
      });
  };

  if (isLoading) {
    return (
      <div>
        <Typography variant="h6">Loading...</Typography>
      </div>
    );
  }
  return (
    <div className="row">
      <Snackbar
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        className="alert-fix"
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <div className="col-12">
        <h5>Configuración facturación {client ? client.business_name : ""}</h5>
      </div>

      <div className="col-3">
        <TextField
          id="start_date"
          name="start_date"
          type="date"
          margin="normal"
          className="ml-2 mt-2"
          InputLabelProps={{
            shrink: true
          }}
          value={clientInvoicingConfig.start_date}
          onChange={e =>
            setClientInvoicingConfig({
              ...clientInvoicingConfig,
              start_date: e.target.value
            })
          }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">Fecha inicio</Typography>
              </InputAdornment>
            ),
            style: { fontSize: "0.75rem" }
          }}
        />
      </div>
      <div className="col-3">
        <TextField
          id="end_date"
          name="end_date"
          type="date"
          margin="normal"
          className="ml-2 mt-2"
          InputLabelProps={{
            shrink: true
          }}
          value={clientInvoicingConfig.end_date}
          onChange={e =>
            setClientInvoicingConfig({
              ...clientInvoicingConfig,
              end_date: e.target.value
            })
          }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Typography variant="caption">Fecha fin</Typography>
              </InputAdornment>
            ),
            style: { fontSize: "0.75rem" }
          }}
        />
      </div>

      <div className="col-12">
        <div className=" d-flex flex-row justify-content-between align-items-center">
          <h5>Cargos</h5>
        </div>
        <div className="row">
          <div className="col-12">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="p-1">Servicio</TableCell>
                  <TableCell className="p-1">Descripción</TableCell>
                  <TableCell className="p-1">Detalles de factura</TableCell>
                  <TableCell className="p-1">Vehículo detallado</TableCell>
                  <TableCell className="p-1">Versión detallada</TableCell>
                  <TableCell className="p-1">Período detallado</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {clientInvoicingConfig.items &&
                  clientInvoicingConfig.items.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell className="p-1">
                        <TextField
                          select
                          value={item.service_charge_id}
                          onChange={e => {
                            const newItems = [...clientInvoicingConfig.items];
                            newItems[index].service_charge_id = e.target.value;
                            setClientInvoicingConfig({
                              ...clientInvoicingConfig,
                              items: newItems
                            });
                          }}
                          margin="normal"
                          className="ml-2 mt-2"
                          InputLabelProps={{
                            shrink: true
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Typography variant="caption">
                                  Servicio
                                </Typography>
                              </InputAdornment>
                            ),
                            style: { fontSize: "0.75rem" }
                          }}
                        >
                          {charges.map(charge => (
                            <MenuItem
                              key={charge.id}
                              value={charge.id}
                              style={{ fontSize: "0.75rem" }}
                            >
                              {charge.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </TableCell>
                      <TableCell className="p-1">
                        <TextField
                          id="description"
                          name="description"
                          margin="normal"
                          className="ml-2 mt-2"
                          value={item.description}
                          onChange={e => {
                            const newItems = [...clientInvoicingConfig.items];
                            newItems[index].description = e.target.value;
                            setClientInvoicingConfig({
                              ...clientInvoicingConfig,
                              items: newItems
                            });
                          }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Typography variant="caption">
                                  Descripción
                                </Typography>
                              </InputAdornment>
                            ),
                            style: { fontSize: "0.75rem" }
                          }}
                        />
                      </TableCell>
                      <TableCell className="p-1">
                        <Checkbox
                          id="invoice_details"
                          name="invoice_details"
                          margin="normal"
                          className="ml-2 mt-2"
                          type="checkbox"
                          checked={item.invoice_details == 1 ? true : false}
                          onChange={e => {
                            const newItems = [...clientInvoicingConfig.items];
                            newItems[index].invoice_details = e.target.checked;
                            setClientInvoicingConfig({
                              ...clientInvoicingConfig,
                              items: newItems
                            });
                          }}
                        />
                      </TableCell>
                      <TableCell className="p-1">
                        <Checkbox
                          id="vehicle_detailed"
                          name="vehicle_detailed"
                          margin="normal"
                          className="ml-2 mt-2"
                          type="checkbox"
                          checked={item.vehicle_detailed == 1 ? true : false}
                          onChange={e => {
                            const newItems = [...clientInvoicingConfig.items];
                            newItems[index].vehicle_detailed = e.target.checked;
                            setClientInvoicingConfig({
                              ...clientInvoicingConfig,
                              items: newItems
                            });
                          }}
                        />
                      </TableCell>
                      <TableCell className="p-1">
                        <Checkbox
                          id="version_detailed"
                          name="version_detailed"
                          margin="normal"
                          className="ml-2 mt-2"
                          type="checkbox"
                          checked={item.version_detailed == 1 ? true : false}
                          onChange={e => {
                            const newItems = [...clientInvoicingConfig.items];
                            newItems[index].version_detailed = e.target.checked;
                            setClientInvoicingConfig({
                              ...clientInvoicingConfig,
                              items: newItems
                            });
                          }}
                        />
                      </TableCell>
                      <TableCell className="p-1">
                        <Checkbox
                          id="period_detailed"
                          name="period_detailed"
                          margin="normal"
                          className="ml-2 mt-2"
                          type="checkbox"
                          checked={item.period_detailed == 1 ? true : false}
                          onChange={e => {
                            const newItems = [...clientInvoicingConfig.items];
                            newItems[index].period_detailed = e.target.checked;
                            setClientInvoicingConfig({
                              ...clientInvoicingConfig,
                              items: newItems
                            });
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>

            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={saving}
            >
              Guardar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientInvoicingConfig;
